import { Link, useLocation } from 'react-router-dom'

import logo from '../../../assets/logo.png'

export function Footer() {
  const { pathname } = useLocation()
  return (
    <div className="flex flex-col mx-auto max-w-screen-lg">
      <footer className="flex flex-col md:flex-row w-full justify-between items-center md:items-start py-8 px-4 xl:px-0">
        <div className="flex flex-col mb-6 md:mb-0">
          <Link
            to={pathname.includes('/temporary')
              ? '#'
              : '/dashboard'}
            onClick={(e) => pathname.includes('/temporary') && e.preventDefault()}
            className="flex flex-col justify-center items-center md:items-start"
          >
            <span
              className="text-center font-bold"
            >
              Relatórios de Trade Marketing
            </span>
            <img
              src={logo}
              alt="App Logo"
              className="w-20"
            />
          </Link>
        </div>
        <p>© {Intl.DateTimeFormat('pt-BR', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date())}</p>
      </footer>
    </div>
  )
}
